// import React from "react";
// import ChangePassword from "../components/ChangePassword";


// const ChangePasswordPage = () => {
//   return (
//     <>

//       <ChangePassword />

//     </>
//   );
// };

// export default ChangePasswordPage;

import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ChangePassword from "../components/ChangePassword";

const ChangePasswordPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
      
        {/* <Breadcrumb title="AI" /> */}


        {/* DashBoardLayerOne */}
        <ChangePassword />

      </MasterLayout>
    </>
  );
};

export default ChangePasswordPage;

